import { useTranslation } from 'react-i18next';

import { Box, Flex, forwardRef, Text, VStack } from '@bonusly/design-system';

import { SelectorOption } from '../../components/selector/selector-option';
import { SelectorBox, SelectorProps } from '../selector/selector-box';
import { useSelector } from '../selector/use-selector';

export const HashtagSelector = forwardRef<SelectorProps<string>, 'div'>(({ command, hash, items, query }, ref) => {
	const { t } = useTranslation('components');
	const { getOptionProps, getSelectorProps, selectedIndex } = useSelector({
		command,
		hash,
		items,
		ref,
	});

	if (!items.length) {
		return null;
	}

	return (
		<SelectorBox>
			<VStack overflowX="auto">
				<Flex
					flexWrap={{ base: 'wrap', xs: 'nowrap' }}
					gap={3}
					justifyContent={{ base: 'center', xs: 'unset' }}
					flexDirection="column"
					w="full"
					{...getSelectorProps()}
				>
					{!query && (
						<Box p={2} color="gray.500" fontSize="sm" fontWeight="normal">
							{t('rich_media.search_hashtags.help_text')}
						</Box>
					)}

					{!items.length && (
						<Box p={2} color="gray.500" fontSize="sm">
							{t('rich_media.no_results')}
						</Box>
					)}

					{items.map((hashtag, index) => (
						<SelectorOption isSelected={selectedIndex === index} key={hashtag} textAlign="left" {...getOptionProps(index)}>
							<Text size="xl" fontWeight="medium">
								#{hashtag}
							</Text>
						</SelectorOption>
					))}
				</Flex>
			</VStack>
		</SelectorBox>
	);
});
